import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CloudinaryUploadComponent } from './CommonComponent/cloudinary-upload/cloudinary-upload.component';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { HandleAvailabilityCheckComponent } from './handle-availability-check/handle-availability-check.component';
import { ConfirmationDialogComponent } from './CommonComponent/confirmation-dialog/confirmation-dialog.component';
import { ShareLocationToggleComponent } from './CommonComponent/share-location-toggle/share-location-toggle.component';
import { DuckingMessageComponent } from './ducking-message/ducking-message.component';

// show hide password
import { ShowHidePasswordComponent } from './CommonComponent/show-hide-password/show-hide-password.component';
import { ShareViaOptionsComponent } from './CommonComponent/share-via-options/share-via-options.component';
import { SharingConfirmationComponent } from './sharing-confirmation/sharing-confirmation.component';
import { ImageDialogComponent } from './CommonComponent/image-dialog/image-dialog.component';
import { PostDetailsComponent } from './post-details/post-details.component';
import { FooterMobileMenuComponent } from './CommonComponent/footer-mobile-menu/footer-mobile-menu.component';
import { ImageViewerModalComponent } from './image-viewer-modal/image-viewer-modal.component';
import { LocationMapModalComponent } from './CommonComponent/location-map-modal/location-map-modal.component';
import { SettingsModalComponent } from './settings-modal/settings-modal.component';
import { NotificationHistoryModalComponent } from './notification-history-modal/notification-history-modal.component';
import { ReactionPickerComponent } from './reaction-picker/reaction-picker.component';
import { ReactionDisplayComponent } from './reaction-display/reaction-display.component';
import { WhoReactedModalComponent } from './who-reacted-modal/who-reacted-modal.component';

// Social Components
import { FollowButtonComponent } from './social/follow-button/follow-button.component';
import { ReportContentComponent } from './social/report-content/report-content.component';


@NgModule({
  declarations: [
    CloudinaryUploadComponent,
    HandleAvailabilityCheckComponent,
    ConfirmationDialogComponent,
    ShareLocationToggleComponent,
    DuckingMessageComponent,
    ShareViaOptionsComponent,
    ShowHidePasswordComponent,
    SharingConfirmationComponent,
    ImageDialogComponent,
    PostDetailsComponent,
    FooterMobileMenuComponent,
    ImageViewerModalComponent,
    LocationMapModalComponent,
    SettingsModalComponent,
    NotificationHistoryModalComponent,
    ReactionPickerComponent,
    ReactionDisplayComponent,
    WhoReactedModalComponent,
    // Social Components
    FollowButtonComponent,
    ReportContentComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    MatDialogModule,
    RouterModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CloudinaryUploadComponent,
    HandleAvailabilityCheckComponent,
    ConfirmationDialogComponent,
    ShareLocationToggleComponent,
    DuckingMessageComponent,
    ShowHidePasswordComponent,
    ShareViaOptionsComponent,
    SharingConfirmationComponent,
    ImageDialogComponent,
    PostDetailsComponent,
    FooterMobileMenuComponent,
    ImageViewerModalComponent,
    LocationMapModalComponent,
    SettingsModalComponent,
    NotificationHistoryModalComponent,
    ReactionPickerComponent,
    ReactionDisplayComponent,
    WhoReactedModalComponent,
    // Social Components
    FollowButtonComponent,
    ReportContentComponent
  ],
  entryComponents: [

  ],
  providers: [
    Camera,
    File,
    {
      provide: MatDialogRef,
      useValue: null
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: null
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule { }
